import {ColumnLayout, ExpandableSection} from '@amzn/awsui-components-react'
import React, {useEffect, useState} from 'react'
import {RouteComponentProps, withRouter} from 'react-router-dom'
import {Iap} from '../../backend/model'
import LabelledValue from '../basic/LabeledValue'
import {convertKeyToLabel} from '../search/SearchUtils'

interface IapSummaryPanelProps extends RouteComponentProps {
    iap: Iap;
}

const IapSummaryPanel: React.FC<IapSummaryPanelProps> = (props) => {
    const [iap, setIap] = useState(props.iap)

    useEffect(() => {
            setIap(props.iap)
        }, [props],
    )

    const renderSummary = () => {
        const iapMetadata = iap.iapMetadata.length > 0 ? iap.iapMetadata[0].matchedMetadata : null
        const columnCount = 1 + (iapMetadata?.length || 0)

        return (
            <ColumnLayout columns={columnCount} minColumnWidth={150} variant="text-grid">
                <LabelledValue id="iapSummaryPanel-iapName" label="Name">{iap.iapName}</LabelledValue>
                {iapMetadata?.map((metadata) => (
                    <LabelledValue key={metadata.key} id={`iapSummaryPanel-${metadata.key}`} label={convertKeyToLabel(metadata.key)}>
                        {metadata.value}
                    </LabelledValue>
                ))}
            </ColumnLayout>
        )
    }

    return (
        <ExpandableSection
            id="iapSummaryPanel"
            variant="container"
            headerText="Summary"
            children={renderSummary()}
            defaultExpanded/>
    )
}

export default withRouter(IapSummaryPanel)
